import { useMemo } from 'react';
import styled from 'styled-components';
import { looksLikeHtml, prepareCollectionHtml } from '../../utils/collectionRichHtml';

function siteOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return String(window.location.origin).replace(/\/$/, '');
  }
  return (process.env.REACT_APP_SITE_URL || '').replace(/\/$/, '');
}

const Html = styled.div`
  margin: 0.75rem 0 0;
  max-width: 40rem;
  opacity: 0.85;
  font-size: ${({ theme }) => theme.type.body};
  line-height: 1.7;

  p {
    margin: 0 0 0.85rem;
  }

  h2,
  h3 {
    font-family: ${({ theme }) => theme.fonts.display};
    font-weight: 400;
    margin: 1.25rem 0 0.5rem;
  }

  ul,
  ol {
    margin: 0 0 0.85rem;
    padding-left: 1.25rem;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

  img {
    max-width: 100%;
    height: auto;
    margin: 1rem 0;
  }
`;

const Plain = styled.p`
  margin: 0.75rem 0 0;
  max-width: 40rem;
  opacity: 0.72;
  font-size: ${({ theme }) => theme.type.body};
`;

export default function CollectionRichHtml({ html, className }) {
  const prepared = useMemo(() => prepareCollectionHtml(html, siteOrigin()), [html]);

  if (!prepared) return null;

  if (!looksLikeHtml(prepared)) {
    return <Plain className={className}>{prepared}</Plain>;
  }

  return <Html className={className} dangerouslySetInnerHTML={{ __html: prepared }} />;
}
